export const DESK_DAYPASS_DEPRECATION_MONTH = '2023-04-01'; // before this date show day passes for desks and overages based on day passes, afterwards show for offices

export const USD_CURRENCY_CODE = 'USD';
